import { shape, oneOf } from 'prop-types';
import { ILabelValuePair } from 'types/shared';

export type SalesTypeValues =
  | 'equivalents'
  | 'streaming'
  | 'downloads'
  | 'track_downloads'
  | 'album_downloads'
  | 'physical'
  | 'radio'
  | 'discoveries';

export type SalesTypeLookup = {
  [key: string]: ILabelValuePair<SalesTypeValues> & {
    base?: string;
    split?: string;
  };
};

const salesTypes: SalesTypeLookup = {
  equivalents: {
    label: 'Album Equivalents',
    value: 'equivalents',
  },
  streaming: {
    label: 'Streams',
    value: 'streaming',
  },
  downloads: {
    label: 'Downloads',
    value: 'downloads',
  },
  track_downloads: {
    label: 'Track Downloads',
    value: 'track_downloads',
    base: 'downloads',
    split: 'track',
  },
  album_downloads: {
    label: 'Release Downloads',
    value: 'album_downloads',
    base: 'downloads',
    split: 'album',
  },
  physical: {
    label: 'Shipped Units',
    value: 'physical',
  },
  radio: {
    label: 'Radio Spins',
    value: 'radio',
  },
  discoveries: {
    label: 'Shazam tags',
    value: 'discoveries',
  },
};

export const salesTypePropType = shape({
  label: oneOf(Object.values(salesTypes).map((salesType) => salesType.label)),
  value: oneOf(Object.values(salesTypes).map((salesType) => salesType.value)),
});

export default salesTypes;
